module.exports = __webpack_public_path__ + "static/img/bgbanner@2x.d59506e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/bgbanner@2x.png
// module id = +ZqB
// module chunks = 18